import Vue from "vue"

/**
 * Start new evaluate session
 * @param {*} formId (course id) 
 * @returns {Promise} js promise object
 */
const getOverviewScore = function (formId, reportKey = null) {
    return Vue.axios.get(`/evaluate/report/${formId}/overview?${reportKey != null ? `report=${reportKey}` : ''}`)
}

export default { getOverviewScore }